/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MembershipPolicySavingsInput { 
    savingProductId?: number;
    minimumSavingsAmount?: number;
    maximumSavingsAmount?: number;
    recurringType?: string | null;
    recurranceAmount?: number | null;
    chargesId?: number | null;
    eventsId?: number | null;
    amountType?: string | null;
    amount?: number | null;
    createAccountOnJoining?: boolean;
    isAutoDebitEnabled?: boolean;
}

